(function () {
  function initMap(root) {
    if (root.getAttribute('data-m-worldmap-init') === 'true') return;
    root.setAttribute('data-m-worldmap-init', 'true');

    var tooltip = root.querySelector('[data-m-worldmap-tooltip]');
    var tooltipText = root.querySelector('[data-m-worldmap-tooltip-text]');
    var sectionWrap = root.closest('.shopify-section') || root.closest('.m-worldmap') || root.closest('section');
    var popup = sectionWrap ? sectionWrap.querySelector('[data-m-worldmap-popup]') : null;
    var popupBody = popup ? popup.querySelector('[data-m-worldmap-popup-body]') : null;
    var templates = sectionWrap ? sectionWrap.querySelectorAll('template[data-m-worldmap-location]') : [];
    var active = null;

    function getMarkerEl(target) {
      if (!target || !target.closest) return null;
      return target.closest('[data-m-location], [data-m-tip], [data-tooltip-content]');
    }

    function getTooltipText(el) {
      if (!el) return '';
      var loc = (el.getAttribute('data-m-location') || '').trim().toLowerCase();
      if (loc) {
        for (var t = 0; t < templates.length; t++) {
          if ((templates[t].getAttribute('data-m-worldmap-key') || '').toLowerCase() === loc) {
            var tr = (templates[t].getAttribute('data-m-worldmap-location') || '').trim();
            if (tr) return tr;
          }
        }
      }
      return (el.getAttribute('data-m-tip') || el.getAttribute('data-tooltip-content') || '').trim();
    }

    function getLocationKey(el) {
      if (!el) return '';
      var loc = (el.getAttribute('data-m-location') || '').trim();
      if (loc) return loc;
      return getTooltipText(el);
    }

    function findTemplate(key) {
      if (!key) return null;
      var normalized = key.toLowerCase();
      for (var k = 0; k < templates.length; k++) {
        if ((templates[k].getAttribute('data-m-worldmap-key') || '').toLowerCase() === normalized) return templates[k];
      }
      for (var i = 0; i < templates.length; i++) {
        var tplKey = (templates[i].getAttribute('data-m-worldmap-location') || '').trim().toLowerCase();
        if (tplKey === normalized) return templates[i];
      }
      return null;
    }

    function getAnchorEl(markerEl) {
      if (!markerEl) return null;
      var pin = markerEl.querySelector('circle[r="12"]');
      if (pin) return pin;
      var dot = markerEl.querySelector(':scope > circle[r="3"]');
      return dot || markerEl;
    }

    function positionTooltipNear(markerEl) {
      if (!tooltip) return;
      var anchor = getAnchorEl(markerEl);
      if (!anchor) return;

      var rootRect = root.getBoundingClientRect();
      var aRect = anchor.getBoundingClientRect();
      var tRect = tooltip.getBoundingClientRect();
      var gap = 10;
      var arrowH = 10;
      var x = aRect.left - rootRect.left + aRect.width / 2 - tRect.width / 2;
      var y = aRect.top - rootRect.top - tRect.height - gap - arrowH;
      x = Math.max(8, Math.min(x, rootRect.width - tRect.width - 8));
      y = Math.max(8, Math.min(y, rootRect.height - tRect.height - 8));
      tooltip.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    }

    function showTooltip(text, el) {
      if (!tooltip || !tooltipText || !text) return;
      tooltipText.textContent = text;
      tooltip.classList.add('is-visible');
      tooltip.setAttribute('aria-hidden', 'false');
      positionTooltipNear(el);
    }

    function hideTooltip() {
      if (!tooltip) return;
      tooltip.classList.remove('is-visible');
      tooltip.setAttribute('aria-hidden', 'true');
      tooltip.style.transform = 'translate3d(-9999px,-9999px,0)';
      active = null;
    }

    function fillPopupBody(tpl) {
      if (!popupBody || !tpl) return;
      popupBody.innerHTML = '';
      if (tpl.content && tpl.content.cloneNode) {
        popupBody.appendChild(tpl.content.cloneNode(true));
      } else {
        popupBody.innerHTML = tpl.innerHTML;
      }
    }

    function openPopup(key) {
      if (!popup || !popupBody) return;
      var tpl = findTemplate(key);
      if (!tpl) return;
      fillPopupBody(tpl);
      popup.classList.add('is-open');
      popup.removeAttribute('hidden');
      document.documentElement.classList.add('m-worldmap-popup-open');
      var closeBtn = popup.querySelector('[data-m-worldmap-popup-close]');
      if (closeBtn) closeBtn.focus();
      hideTooltip();
    }

    function closePopup() {
      if (!popup) return;
      popup.classList.remove('is-open');
      popup.setAttribute('hidden', '');
      document.documentElement.classList.remove('m-worldmap-popup-open');
      if (popupBody) popupBody.innerHTML = '';
    }

    function handleMarkerActivate(el) {
      if (!el) return;
      var key = getLocationKey(el);
      if (!findTemplate(key)) return;
      openPopup(key);
    }

    root.addEventListener('pointerover', function (e) {
      var el = getMarkerEl(e.target);
      if (!el) return;
      active = el;
      showTooltip(getTooltipText(el), el);
    });

    root.addEventListener('pointerout', function (e) {
      if (!active) return;
      var to = e.relatedTarget;
      if (to && active.contains && active.contains(to)) return;
      hideTooltip();
    });

    root.addEventListener('focusin', function (e) {
      var el = getMarkerEl(e.target);
      if (!el) return;
      active = el;
      showTooltip(getTooltipText(el), el);
    });

    root.addEventListener('focusout', function () {
      hideTooltip();
    });

    root.addEventListener('click', function (e) {
      var el = getMarkerEl(e.target);
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      handleMarkerActivate(el);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = getMarkerEl(e.target);
      if (!el) return;
      e.preventDefault();
      handleMarkerActivate(el);
    });

    if (popup) {
      popup.addEventListener('click', function (e) {
        if (e.target.closest('[data-m-worldmap-popup-close], [data-m-worldmap-popup-backdrop]')) {
          closePopup();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup && popup.classList.contains('is-open')) closePopup();
    });

    window.addEventListener(
      'scroll',
      function () {
        if (active && tooltip && tooltip.classList.contains('is-visible')) positionTooltipNear(active);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      if (active && tooltip && tooltip.classList.contains('is-visible')) positionTooltipNear(active);
    });
  }

  function boot() {
    document.querySelectorAll('[data-m-worldmap]').forEach(initMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-m-worldmap]').forEach(initMap);
  });
})();
